import {ReactNode, ReactElement, SyntheticEvent} from 'react';

import {UIState} from 'coreStore/data/ui/types';
import {ICategory} from 'coreStore/data/categories/types';

export enum ENavigationItemViewAll {
	'None' = 'none',
	'Show on Large Screens' = '>=xx-large',
	'Show on Small Screens' = '<xx-large',
	'Show on All Screens' = 'all',
}

interface INavigationParent {
	id: string;
	type: string;
	parent?: INavigationParent;
}

export interface INavigationItemProps {
	id?: string;
	title?: string;
	color?: string;
	url?: string;
	viewAll?: {
		url: string;
		show: ENavigationItemViewAll;
	};
	template?: ReactNode;
	children?: ReactNode;
	isActive?: boolean;
	hasActive?: boolean;
	hasSubLists?: boolean;
	navigationStack?: UIState['navigationStack'];
	handleNavigationItemClick?: (event: SyntheticEvent) => void;
	animationClasses?: string;
	parent?: INavigationParent;
	isInHeaderContext?: boolean;
	description?: string;
	isFlatSubList?: boolean;
	navigationParams?: any;
	queryParameters?: string;
	hasHiddenChildren?: boolean;
	isFlatSubItem?: boolean;
	image?: ReactNode;
	customSettings?: {
		showEditorialContent?: boolean;
		showImage?: boolean;
	};
}

export interface INavigationItemOldProps {
	root?: ReactNode;
	category?: {
		items: Array<ICategory>;
		type: string;
	};
	title?: string;
	color?: string;
	viewAll?: ENavigationItemViewAll;
	targetPage?: ReactElement;
	targetUrl?: string;
	children?: ReactNode[];
	apiCategory?: any;
	subItemsCollection?: {
		items: INavigationItemOldProps[];
	};
	subItems?: {props: any; total: number};
	sys?: {
		id?: string;
	};
	template: ReactNode;
	parent?: INavigationParent;
	description?: string;
	isFlatSubCategoriesContainer?: boolean;
	isFlatSubList?: boolean;
	isFlatSubItem?: boolean;
	navigationParams?: any;
	queryParameters?: Record<string, string>;
	sorting?: string;
	hasHiddenChildren?: boolean;
	image?: any;
	media?: any;
	imageTitle?: string;
	customSettings?: Record<string, any>;
	editorialContent?: any;
}

export enum ENavigationItemsSortingOrder {
	ASCEND = 'A-Z',
	DESCEND = 'Z-A',
	NONE = 'none',
}
